import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import floder from "../../../../../assets/images/folder3.png";
import { useDispatch, useSelector } from "react-redux";
import { getfolder, getfolder as getFolderApi, getMoveFolder, mediaMove, updateFolder } from "live-slices/media-center/thunk"
import { createSelector } from "reselect";
import { toast } from "react-toastify";
import CreateFolder from "./CreateFolder";
import { createFolder as createFolderApi } from "live-slices/media-center/thunk";
import MediaBreadCrumb from "./MediaBreadCrumb";



const MoveToFolderModal = ({ show, onCloseClick, submitButton, selectedFolderId }: {
  submitButton: (moveFolderId?: string) => void;
  onCloseClick: () => void;
  show: boolean;
  selectedFolderId?: any; 
}) => {
  const dispatch = useDispatch<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  console.log(selectedFolderId )
  const [movefolderStack, setMoveFolderStack] = useState<{ name: string, id: string }[]>([]);
  const [selectedFolderName, setSelectedFolderName] = useState<string | null>(null);
  const [newFolderId, setNewFolderId] = useState('');
  const [createMoveFolder, setCreateMoveFolder] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [folderName, setFolderName] = useState('');
  const [parentId, setParentId] = useState(null);
  const [folderId, setFolderId] = useState('');



  const movefolderData = createSelector(
    (state: any) => state.MediaCenter,
    (moveToFolders) => moveToFolders?.moveToFolders
  );
  const moveToFolders = useSelector(movefolderData);

  const handleSubmit = async () => {
    setIsLoadingButton(true);
    try {
      await submitButton(newFolderId); // Wait for the async action to complete
    } catch (error) {
      console.error("Error during submission:", error);
    } finally {
      setIsLoadingButton(false); // Reset loading state
    }
  };


  useEffect(() => {
    if (show) {
      dispatch(getMoveFolder(''));
      setMoveFolderStack([]);
      setSelectedFolderName("");
      setNewFolderId("");
    }
  }, [show, dispatch]);

  const handleNewFolderClick = async (folderName: string, folderId: string) => {
    setIsLoading(true);
    try {
      setMoveFolderStack((prevStack) => [...prevStack, { name: folderName, id: folderId }]);
      setSelectedFolderName(folderName);
      setNewFolderId(folderId);
      await dispatch(getMoveFolder(folderId));
    } catch (error) {
      console.error("Error fetching folder data", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitt = async ({ folderName, parentId, _id }: { folderName: string; parentId?: string; _id?: any }) => {
    const moveparentId = movefolderStack.length > 0 ? movefolderStack[movefolderStack.length - 1].id : "";

    try {
      const result = await dispatch(createFolderApi({ folderName, parentId: moveparentId }))
      if (result?.error && result.error.message === 'Rejected') {
        setCreateMoveFolder(true);
      } else {
        await
          setTimeout(() => {
            dispatch(getMoveFolder(moveparentId));
            toast.success("Folder Created Successfully!", { autoClose: 1000 });
            dispatch(getfolder(movefolderStack.length > 0 ? movefolderStack[movefolderStack.length - 1].id : ""))
            setCreateMoveFolder(false);
          }, 1000);

      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleBackClick = async (index: number, id: string = "", name: string = "Image") => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      const selectedFolder = movefolderStack[index];
      if (id === "") {
        selectedFolder.id = "";
        selectedFolder.name = name;  // Reset the name to "Image" when navigating to root
      }

      await dispatch(getMoveFolder(selectedFolder.id));
      setMoveFolderStack((prevStack) => prevStack.slice(0, index + 1));

    } catch (error) {
      console.error("Error fetching folder data", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} className=" imageUpladmodal position-relative" backdrop="static">
      <ModalBody className="py-3 px-5">
        <div className="d-flex justify-content-between align-items-center">
          <h4>Media Center</h4>
          <i
            className="bx bx-x fs-2 cursor-pointer"
            data-testing-id="closeIcon_movetofolder"
            style={{ color: "#CACACA" }}
            onClick={onCloseClick}
          ></i>
        </div>
        {movefolderStack.length > 0 && (
          <MediaBreadCrumb folderStack={movefolderStack} handleBackClick={handleBackClick} isLoading={isLoading} />
        )}

        <div className="ImageRow d-flex justify-content-start align-items-center flex-wrap gap-3 mb-3">
          {isLoading ? (
            <div className="loader">Loading...</div>
          ) : moveToFolders && moveToFolders.length > 0 ? (
            moveToFolders
              .filter((item: any) => item._id !== selectedFolderId) 
              .map((item: any, index: number) => (
              <div
                key={item._id}
                className="imageBoxActive avatar-sm rounded-2 d-flex justify-content-start align-items-center flex-column gap-2 py-2"
                data-testing-Id={'folder_movetofolder' + index}
                style={{
                  cursor: 'pointer',
                  width: '140px',
                  height: '200px',
                  background: 'rgb(243 243 243)',
                }}
                onClick={() => handleNewFolderClick(item.folderName, item._id)}
              >
                {/* <div className="d-flex justify-content-end fs-3 w-100 z-3">
                                                                <i
                                                                    id="hoverPopover"
                                                                    className="bx bx-dots-horizontal-rounded me-2"
                                                                    style={{ color: "#CACACA", cursor: "pointer" }}
                                                                    onMouseEnter={handleMouseEnter} 
                                                                    onMouseLeave={handleMouseLeave} 
                                                                ></i>

                                                                
                                                                <Popover
                                                                    placement="bottom"
                                                                    isOpen={popoverOpen}
                                                                    target="hoverPopover"
                                                                    trigger="manual" 
                                                                >
                                                                    <PopoverBody
                                                                        onMouseEnter={handleMouseEnter} 
                                                                        onMouseLeave={handleMouseLeave} 
                                                                        className=" px-0 py-3"
                                                                    >
                                                                        <div className="d-flex flex-column gap-2">
                                                                            <div className="activeItemsPop w-100 px-2" onClick={() => setCreateFolder(true)}>
                                                                            <p  className=" text-decoration-none text-dark p-0 m-0 cursor-pointer">
                                                                                Edit
                                                                            </p>
                                                                            </div>
                                                                           <div className="activeItemsPop w-100 px-2">
                                                                           <p  className="text-decoration-none text-dark m-0 p-0 cursor-pointer ">
                                                                                Delete
                                                                            </p>
                                                                           </div>
                                                                            <div className="activeItemsPop w-100 px-2">
                                                                            <p  className="text-decoration-none text-dark p-0 m-0 cursor-pointer">
                                                                                Export URL
                                                                            </p>
                                                                            </div>

                                                                        </div>
                                                                    </PopoverBody>
                                                                </Popover>
                                                            </div> */}

                <div style={{ width: '120px', height: '130px' }} className="mb-3">
                  <img
                    src={floder}
                    alt="Folder Image"
                    className="img-fluid d-block w-100 h-100"
                  />
                </div>
                <p
                  className="m-0 text-center fs-6"
                  style={{
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    width: '110px',
                  }}
                >
                  {item.folderName || 'Folder Name'}
                </p>
              </div>
            ))
          ) : (
            <p>No folders available</p>
          )}
        </div>
      </ModalBody>
      <div
        className="d-flex justify-content-between align-items-center position-sticky w-100 bottom-0 bg-white p-3 buttonMomve"
        style={{ boxShadow: "0px 0px 11px -4px #CACACA" }}
      >
        <button
          className="btn btn-outline-secondary creatFolder"
          type="submit"
          data-testing-id="newFolderButtonUpload_movetofolder"
          onClick={() => setCreateMoveFolder(true)}
        >
          Create New Folder
        </button>
        <div className="text-end towButton">
          <button
            className="btn btn-outline-dark lightGrayButton me-3"
            type="submit"
            onClick={onCloseClick}
            data-testing-id="cancelButtonUpload_movetofolder"
            disabled={isLoadingButton} // Disable button when isLoading is true
          >
            Cancel
          </button>
          <button
            type="button"
            className={`btn btn-secondary ${isLoadingButton ? "disabled" : ""}`}
            data-testing-id="confirmButton_movetofolder"
            onClick={!isLoadingButton ? handleSubmit : undefined} // Prevent multiple clicks
          >
            {isLoadingButton ? (
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : (
              "Confirm"
            )}
          </button>

        </div>
      </div>
      <CreateFolder
        show={createMoveFolder}
        folderName={folderName}
        parentId={parentId}
        _id={moveToFolders?._id}
        submitButton={(folderName, parentId,) => handleSubmitt({ folderName, parentId, _id: folderId })}
        onCloseClick={() => setCreateMoveFolder(false)}
        isEdit={isEdit}
      />
    </Modal>
  );
};

MoveToFolderModal.propTypes = {
  onCloseClick: PropTypes.func,
  onSubmitClick: PropTypes.func,
  show: PropTypes.any,
  selectedMediaIds: PropTypes.arrayOf(PropTypes.string),
  selectedFolderId: PropTypes.string.isRequired,

  // newFolderId: PropTypes.string,
};

export default MoveToFolderModal;